module.exports = __webpack_public_path__ + "img/320_3.be872eba.jpg";